(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format((cents || 0) / 100);
  }

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/^salford\s+(rum|gin)\s*-\s*/, '')
      .replace(/^salford\s+distillery\s*-\s*/, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function aliases(value) {
    var name = normalise(value);
    var list = [name];
    if (name.indexOf('honey') !== -1) list.push('honey rum', 'spiced honey');
    if (name.indexOf('coffee') !== -1) list.push('coffee rum');
    if (name === 'original dry' || name.indexOf('original dry gin') !== -1) list.push('original dry gin');
    if (name.indexOf('original golden') !== -1 || name === 'original spiced' || name === 'spiced rum') {
      list.push('original golden spiced', 'original spiced rum');
    }
    if (name.indexOf('dark') !== -1) list.push('dark spice', 'dark spiced', 'dark spice rum', 'dark spiced rum');
    if (name.indexOf('rhubarb') !== -1) list.push('rhubarb gin');
    if (name.indexOf('cherry') !== -1) list.push('cherry rum', 'cherry spiced', 'salford cherry spiced rum');
    if (name.indexOf('black') !== -1) list.push('rum black', 'rum and black');
    return list.filter(function (item, index, self) {
      return item && self.indexOf(item) === index;
    });
  }

  ready(function () {
    var dataNode = document.getElementById('Salford3BottleBundleJson');
    var builder = document.querySelector('[data-salford-3-bottle-builder]');
    if (!dataNode || !builder || builder.dataset.salford3BottleReady === 'true') return;
    builder.dataset.salford3BottleReady = 'true';

    var data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    var bottles = data.bottles || [];
    var bundle = data.bundle || {};
    var engravingProduct = data.engraving || {};
    var copy = data.copy || {};
    if (!bottles.length || !bundle.variants || !bundle.variants.length) return;

    var state = {
      slots: [bottles[0] || null, bottles[1] || bottles[0] || null, bottles[2] || bottles[0] || null],
      activeSlot: 0,
      choosingOpen: [true, true, true],
      mobileChoiceIndex: [0, Math.min(1, bottles.length - 1), Math.min(2, bottles.length - 1)],
      viewingAll: [false, false, false],
      selectedVariant: null,
      adding: false,
      redirecting: false,
      engravings: [
        { selected: false, text: '' },
        { selected: false, text: '' },
        { selected: false, text: '' }
      ]
    };

    var selectors = {
      lists: '[data-salford-3-bottle-list]',
      groups: '[data-salford-3-bottle-group]',
      toggle: '[data-salford-3-bottle-toggle]',
      selectedLabel: '[data-salford-3-bottle-selected-label]',
      select: '[data-salford-3-bottle-select]',
      option: '[data-salford-3-bottle-option]',
      progress: '[data-salford-3-bottle-progress]',
      progressButton: '[data-salford-3-bottle-progress-button]',
      next: '[data-salford-3-bottle-next]',
      back: '[data-salford-3-bottle-back]',
      mobilePrev: '[data-salford-3-bottle-mobile-prev]',
      mobileNext: '[data-salford-3-bottle-mobile-next]',
      viewAll: '[data-salford-3-bottle-view-all]',
      selectMedia: '[data-salford-3-bottle-select-media]',
      selectTitle: '[data-salford-3-bottle-select-title]',
      selectMeta: '[data-salford-3-bottle-select-meta]',
      variantInput: '[data-salford-3-bottle-variant-id]',
      summaryTitle: '[data-salford-3-bottle-summary-title]',
      summaryMedia: '[data-salford-3-bottle-summary-media]',
      summaryPrice: '[data-salford-3-bottle-summary-price]',
      comparePrice: '[data-salford-3-bottle-compare-price]',
      price: '[data-salford-3-bottle-price]',
      saving: '[data-salford-3-bottle-saving]',
      summaryHelper: '[data-salford-3-bottle-summary-helper]',
      engravingRow: '[data-salford-3-bottle-engraving-row]',
      engravingPrice: '[data-salford-3-bottle-engraving-price]',
      engravingToggle: '[data-salford-3-bottle-engraving-toggle]',
      engravingText: '[data-salford-3-bottle-engraving-text]',
      mobilePrice: '[data-salford-3-bottle-mobile-price]',
      savings: '[data-salford-3-bottle-savings]',
      availability: '[data-salford-3-bottle-availability]',
      add: '[data-salford-3-bottle-add]',
      mobileAdd: '[data-salford-3-bottle-mobile-add]',
      form: '[data-salford-3-bottle-form]',
      message: '[data-salford-3-bottle-message]',
      mobileSelection: '[data-salford-3-bottle-mobile-selection]',
      mobileCta: '[data-salford-3-bottle-mobile-cta]'
    };

    var mobileCta = document.querySelector(selectors.mobileCta);
    if (mobileCta && mobileCta.parentElement !== document.body) {
      document.body.appendChild(mobileCta);
    }

    function selectedTotal() {
      return state.slots.reduce(function (total, bottle) {
        return total + (bottle && bottle.price ? bottle.price : 0);
      }, 0);
    }

    function matchingVariant() {
      if (state.slots.some(function (bottle) { return !bottle; })) return null;
      var selectedAliases = state.slots.map(function (bottle) {
        return aliases(bottle && (bottle.bundleValue || bottle.label || bottle.title));
      });

      return bundle.variants.find(function (variant) {
        var options = (variant.options || []).map(normalise);
        return selectedAliases.every(function (nameAliases, index) {
          return nameAliases.indexOf(options[index]) !== -1;
        });
      }) || bundle.variants.find(function (variant) {
        if (!variant.available) return false;
        var options = (variant.options || []).map(normalise);
        return selectedAliases.every(function (nameAliases, index) {
          return nameAliases.indexOf(options[index]) !== -1;
        });
      }) || null;
    }

    function setText(selector, text) {
      document.querySelectorAll(selector).forEach(function (element) {
        element.textContent = text || '';
      });
    }

    function setDisabled(selector, disabled) {
      document.querySelectorAll(selector).forEach(function (element) {
        element.disabled = disabled;
        element.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      });
    }

    function scrollToActiveStep() {
      var activeGroup = builder.querySelector('[data-salford-3-bottle-group].is-active');
      var target = activeGroup && activeGroup.querySelector(selectors.select) ? activeGroup.querySelector(selectors.select) : activeGroup;
      if (!target) return;
      window.requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    function setButtonState() {
      document.querySelectorAll(selectors.add + ', ' + selectors.mobileAdd).forEach(function (button) {
        if (!button.dataset.originalLabel) button.dataset.originalLabel = button.innerHTML;
        button.innerHTML = state.adding ? copy.adding : button.dataset.originalLabel;
        button.classList.toggle('is-adding', state.adding);
        button.setAttribute('aria-busy', state.adding ? 'true' : 'false');
      });
    }

    function choiceMarkup(bottle, slotIndex, bottleIndex) {
      var selected = state.slots[slotIndex] && String(state.slots[slotIndex].id) === String(bottle.id);
      var mobileActive = Number(state.mobileChoiceIndex[slotIndex]) === bottleIndex;
      return '<button type="button" class="salford-3-bottle-option' + (mobileActive ? ' is-mobile-active' : '') + '" ' +
        'data-salford-3-bottle-option data-slot-index="' + slotIndex + '" data-bottle-id="' + bottle.id + '" data-bottle-index="' + bottleIndex + '" aria-selected="' + (selected ? 'true' : 'false') + '">' +
        (bottle.image ? '<img src="' + bottle.image + '" alt="' + escapeHtml(bottle.imageAlt || bottle.title) + '" loading="lazy">' : '') +
        '<span><strong>' + escapeHtml(bottle.label || bottle.title) + '</strong><small>' + escapeHtml(bottle.meta || '') + '</small></span>' +
        '<em>' + escapeHtml(bottle.priceFormatted || '') + '</em>' +
        '<i aria-hidden="true">' + (selected ? '✓' : '+') + '</i>' +
        '<b class="salford-3-bottle-option__select">Select this bottle</b>' +
      '</button>';
    }

    function renderChoices() {
      document.querySelectorAll(selectors.lists).forEach(function (list) {
        var slotIndex = Number(list.closest('[data-slot-index]').getAttribute('data-slot-index'));
        list.innerHTML = bottles.map(function (bottle, bottleIndex) {
          return choiceMarkup(bottle, slotIndex, bottleIndex);
        }).join('');
      });
    }

    function updateStepState() {
      document.querySelectorAll(selectors.groups).forEach(function (group) {
        var slotIndex = Number(group.getAttribute('data-slot-index'));
        var bottle = state.slots[slotIndex];
        var isActive = slotIndex === state.activeSlot;
        group.classList.toggle('is-open', isActive);
        group.classList.toggle('is-active', isActive);
        group.classList.toggle('is-choosing', isActive && Boolean(state.choosingOpen[slotIndex]));
        group.classList.toggle('is-viewing-all', Boolean(state.viewingAll[slotIndex]));
        group.classList.toggle('is-complete', Boolean(bottle));
        group.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        group.querySelectorAll('[data-salford-3-bottle-selected-label]').forEach(function (element) {
          element.textContent = bottle ? bottle.label : '';
        });
        group.querySelectorAll('[data-salford-3-bottle-select-media]').forEach(function (element) {
          element.innerHTML = bottle && bottle.image ? '<img src="' + bottle.image + '" alt="" loading="lazy">' : '';
        });
        group.querySelectorAll('[data-salford-3-bottle-select-title]').forEach(function (element) {
          element.textContent = bottle ? bottle.label : copy.chooseBottle;
        });
        group.querySelectorAll('[data-salford-3-bottle-select-meta]').forEach(function (element) {
          element.textContent = bottle ? bottle.meta : '';
        });
        group.querySelectorAll('[data-salford-3-bottle-slot-engraving]').forEach(function (element) {
          var engraving = state.engravings[slotIndex];
          element.classList.toggle('is-selected', Boolean(engraving && engraving.selected));
        });
        group.querySelectorAll(selectors.viewAll).forEach(function (button) {
          button.textContent = state.viewingAll[slotIndex] ? 'Show featured bottle' : 'View all spirits';
        });
      });

      document.querySelectorAll(selectors.progress).forEach(function (item) {
        var stepIndex = Number(item.getAttribute('data-salford-3-bottle-progress'));
        item.classList.toggle('is-active', stepIndex === state.activeSlot);
        item.classList.toggle('is-complete', stepIndex < state.activeSlot || (stepIndex < 3 && Boolean(state.slots[stepIndex])));
      });

      builder.classList.toggle('is-reviewing', state.activeSlot === 3);
    }

    function updateSummary() {
      state.selectedVariant = matchingVariant();
      var total = selectedTotal();
      var compare = formatMoney(total);
      var engravingCount = state.engravings.filter(function (engraving) {
        return engraving.selected;
      }).length;
      var engravingTotal = engravingCount * (copy.engravingPrice || 0);
      var engravingVariant = engravingVariantForCount(engravingCount);
      var engravingAvailable = engravingCount === 0 || Boolean(engravingVariant && engravingVariant.available);
      var finalPriceCents = (copy.bundlePrice || 0) + engravingTotal;
      var bundlePrice = formatMoney(finalPriceCents);
      var saving = formatMoney(Math.max(0, total - (copy.bundlePrice || 0)));
      var available = state.selectedVariant && state.selectedVariant.available && engravingAvailable;
      var hasAllBottles = state.slots.every(Boolean);

      state.slots.forEach(function (bottle, index) {
        setText('[data-salford-3-bottle-summary-title="' + index + '"]', bottle ? bottle.label : String(index + 1));
        setText('[data-salford-3-bottle-summary-price="' + index + '"]', bottle ? bottle.priceFormatted : '');
        document.querySelectorAll('[data-salford-3-bottle-summary-media="' + index + '"]').forEach(function (element) {
          element.innerHTML = bottle && bottle.image ? '<img src="' + bottle.image + '" alt="" loading="lazy">' : '<svg viewBox="0 0 24 24" focusable="false"><path d="M9 3h6"/><path d="M10 3v5l-2 3v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-8l-2-3V3"/><path d="M9 13h6"/></svg>';
        });
      });

      setText(selectors.comparePrice, hasAllBottles ? compare : '');
      setText(selectors.saving, hasAllBottles ? saving : '');
      setText(selectors.price, bundlePrice);
      setText(selectors.mobilePrice, bundlePrice);
      setText(selectors.mobileSelection, state.slots.map(function (bottle) {
        return bottle ? bottle.label : '';
      }).filter(Boolean).join(' + ') || copy.chooseBottle);
      document.querySelectorAll(selectors.engravingRow).forEach(function (row) {
        row.hidden = engravingCount === 0;
      });
      setText(selectors.engravingPrice, engravingCount ? '+' + formatMoney(engravingTotal) : '');
      setText(selectors.savings, hasAllBottles ? 'Bundle price applied automatically.' : 'Choose 3 bottles to complete your bundle.');
      setText(selectors.summaryHelper, hasAllBottles ? 'Ready to add to cart' : 'Add 3 bottles to complete your bundle');
      setText(selectors.availability, hasAllBottles ? (state.selectedVariant ? (available ? '' : copy.soldOut) : copy.unavailable) : '');

      document.querySelectorAll(selectors.variantInput).forEach(function (input) {
        input.value = state.selectedVariant ? state.selectedVariant.id : '';
      });

      setDisabled(selectors.add, !hasAllBottles || !available || state.adding);
      setDisabled(selectors.mobileAdd, !hasAllBottles || !available || state.adding);
      setDisabled(selectors.next, !state.slots[Math.min(state.activeSlot, 2)]);
      setButtonState();
      renderChoices();
      updateStepState();
    }

    function cartProperties() {
      var properties = {};
      properties[copy.bundlePropertyName || '_Bundle Offer'] = copy.bundlePropertyValue || '3 bottle bundle';
      state.slots.forEach(function (bottle, index) {
        properties[(copy.bottlePropertyPrefix || 'Bottle') + ' ' + (index + 1)] = bottle ? bottle.label : '';
      });
      state.engravings.forEach(function (engraving, index) {
        if (!engraving.selected) return;
        var bottle = state.slots[index];
        var bottleLabel = bottle ? bottle.label : 'Bottle ' + (index + 1);
        properties[(copy.engravingPropertyName || '_Engraving Selected') + ' - Bottle ' + (index + 1)] = bottleLabel;
        if (engraving.text) {
          properties[(copy.engravingTextPropertyName || 'Engraving Text') + ' - Bottle ' + (index + 1)] = engraving.text;
        }
      });
      return properties;
    }

    function engravingCount() {
      return state.engravings.filter(function (engraving) {
        return engraving.selected;
      }).length;
    }

    function engravingVariantForCount(count) {
      if (!count || !engravingProduct.variants || !engravingProduct.variants.length) return null;
      var numberWords = ['', 'one', 'two', 'three'];
      var countWord = numberWords[count] || String(count);

      return engravingProduct.variants.find(function (variant) {
        var title = normalise(variant.title);
        var options = (variant.options || []).map(normalise).join(' ');
        return title.indexOf(countWord) !== -1 || options.indexOf(countWord) !== -1;
      }) || engravingProduct.variants.find(function (variant) {
        return Number(variant.price || 0) === (copy.engravingPrice || 0) * count;
      }) || null;
    }

    function engravingProperties() {
      var properties = {
        '_Add-on for': copy.bundlePropertyValue || '3 bottle bundle'
      };

      state.engravings.forEach(function (engraving, index) {
        if (!engraving.selected) return;
        var bottle = state.slots[index];
        var bottleLabel = bottle ? bottle.label : 'Bottle ' + (index + 1);
        properties['Bottle ' + (index + 1)] = bottleLabel;
        properties['Engraving Text - Bottle ' + (index + 1)] = engraving.text || 'Engraving selected';
      });

      return properties;
    }

    function addPayload() {
      var items = [{
        id: state.selectedVariant.id,
        quantity: 1,
        properties: cartProperties()
      }];
      var count = engravingCount();
      var engravingVariant = engravingVariantForCount(count);

      if (count && engravingVariant && engravingVariant.available) {
        items.push({
          id: engravingVariant.id,
          quantity: 1,
          properties: engravingProperties()
        });
      }

      return { items: items };
    }

    function addToCart() {
      if (!state.selectedVariant || !state.selectedVariant.available || state.adding) return;

      state.adding = true;
      state.redirecting = false;
      setText(selectors.message, '');
      updateSummary();

      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(addPayload())
      }).then(function (response) {
        if (!response.ok) {
          return response.json().then(function (error) {
            throw new Error(error.description || copy.error);
          });
        }
        return response.json();
      }).then(function () {
        state.redirecting = true;
        setText(selectors.message, copy.added);
        window.location.href = root + 'cart';
      }).catch(function (error) {
        state.adding = false;
        setText(selectors.message, error.message || copy.error);
        updateSummary();
      }).finally(function () {
        if (state.redirecting) return;
        state.adding = false;
        updateSummary();
      });
    }

    document.addEventListener('click', function (event) {
      var option = event.target.closest(selectors.option);
      if (option) {
        var slotIndex = Number(option.getAttribute('data-slot-index'));
        var bottleId = option.getAttribute('data-bottle-id');
        var bottle = bottles.find(function (item) {
          return String(item.id) === String(bottleId);
        });
        if (bottle) {
          var bottleIndex = Number(option.getAttribute('data-bottle-index')) || 0;
          state.slots[slotIndex] = bottle;
          state.activeSlot = slotIndex;
          state.mobileChoiceIndex[slotIndex] = bottleIndex;
          state.choosingOpen[slotIndex] = false;
          state.viewingAll[slotIndex] = false;
          setText(selectors.message, '');
          updateSummary();
          scrollToActiveStep();
        }
        return;
      }

      var toggle = event.target.closest(selectors.toggle);
      if (toggle) {
        state.activeSlot = Number(toggle.getAttribute('data-slot-index')) || 0;
        state.choosingOpen[state.activeSlot] = true;
        updateSummary();
        return;
      }

      var progressButton = event.target.closest(selectors.progressButton);
      if (progressButton) {
        state.activeSlot = Math.max(0, Math.min(3, Number(progressButton.getAttribute('data-slot-index')) || 0));
        if (state.activeSlot < 3) state.choosingOpen[state.activeSlot] = true;
        setText(selectors.message, '');
        updateSummary();
        builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      if (event.target.closest(selectors.next)) {
        state.activeSlot = Math.min(state.activeSlot + 1, 3);
        if (state.activeSlot < 3) state.choosingOpen[state.activeSlot] = true;
        setText(selectors.message, '');
        updateSummary();
        builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      if (event.target.closest(selectors.back)) {
        state.activeSlot = Math.max(state.activeSlot - 1, 0);
        state.choosingOpen[state.activeSlot] = true;
        setText(selectors.message, '');
        updateSummary();
        builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      var mobilePrev = event.target.closest(selectors.mobilePrev);
      var mobileNext = event.target.closest(selectors.mobileNext);
      if (mobilePrev || mobileNext) {
        var arrowGroup = event.target.closest(selectors.groups);
        if (!arrowGroup || !bottles.length) return;
        var arrowSlotIndex = Number(arrowGroup.getAttribute('data-slot-index')) || 0;
        var direction = mobileNext ? 1 : -1;
        state.activeSlot = arrowSlotIndex;
        state.choosingOpen[arrowSlotIndex] = true;
        state.viewingAll[arrowSlotIndex] = false;
        state.mobileChoiceIndex[arrowSlotIndex] = (Number(state.mobileChoiceIndex[arrowSlotIndex]) + direction + bottles.length) % bottles.length;
        updateSummary();
        return;
      }

      var viewAll = event.target.closest(selectors.viewAll);
      if (viewAll) {
        var viewAllGroup = event.target.closest(selectors.groups);
        if (!viewAllGroup) return;
        var viewAllSlotIndex = Number(viewAllGroup.getAttribute('data-slot-index')) || 0;
        state.activeSlot = viewAllSlotIndex;
        state.choosingOpen[viewAllSlotIndex] = true;
        state.viewingAll[viewAllSlotIndex] = !state.viewingAll[viewAllSlotIndex];
        updateSummary();
        return;
      }

      var select = event.target.closest(selectors.select);
      if (select) {
        state.activeSlot = Number(select.getAttribute('data-slot-index')) || 0;
        state.choosingOpen[state.activeSlot] = !state.choosingOpen[state.activeSlot];
        state.viewingAll[state.activeSlot] = false;
        updateStepState();
      }
    });

    document.addEventListener('change', function (event) {
      if (!event.target.matches(selectors.engravingToggle)) return;
      var slotIndex = Number(event.target.getAttribute('data-slot-index')) || 0;
      state.engravings[slotIndex].selected = event.target.checked;
      var wrapper = event.target.closest('[data-salford-3-bottle-slot-engraving]');
      if (wrapper) wrapper.classList.toggle('is-selected', event.target.checked);
      updateSummary();
    });

    document.addEventListener('input', function (event) {
      if (!event.target.matches(selectors.engravingText)) return;
      var slotIndex = Number(event.target.getAttribute('data-slot-index')) || 0;
      state.engravings[slotIndex].text = event.target.value.trim();
    });

    document.addEventListener('submit', function (event) {
      if (!event.target.matches(selectors.form)) return;
      event.preventDefault();
      addToCart();
    });

    renderChoices();
    updateSummary();
  });
})();
